import layout from '@/layout'

export default {
  path: '/application',
  component: layout,
  redirect: '/application/mobile',
  name: 'functionModule',
  meta: {
    title: '应用管理',
    icon: 'application'
  },
  children: [
    {
      path: '/application/mobile',
      // redirect: '/application/mobile?type=1',
      component: () => import('@/views/application/authModule'),
      meta: {
        title: '移动应用',
        icon: 'application-two'
      }
    }
    // {
    //   path: '/application/mobile/:id',
    //   component: () => import('@/views/application/authModule/info'),
    //   meta: {
    //     title: '移动应用详情'
    //   }
    // }
  ]
}
